var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"px-3"},[_c('Header',{attrs:{"title":_vm.titleHeader,"token":_vm.showToken,"background":_vm.showBg,"coin":_vm.coin}}),_c('div',{staticClass:"pt-6"},[_c('Skor'),_c('Liststore')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }